import BoletimSanitario from "./pages/BoletimSanitario";
import PesquisaBoletimSanitario from "./pages/PesquisaBoletimSanitario";
import MercadoDestino from "./pages/MercadoDestino";
import DetalheMercadoDestino from "./components/mercadoDestino/DetalheMercadoDestino";
import DadosBoletimSanitario from "./components/DadosBoletimSanitario";
import MedicacaoBoletimSanitario from "./components/MedicacaoBoletimSanitario";
import SinalClinicoBoletimSanitario from "./components/SinalClinicoBoletimSanitario";
import MercadoDestinoBoletimSanitario from "./components/MercadoDestinoBoletimSanitario";
import ResumoBoletimSanitario from "./components/ResumoBoletimSanitario";

export default [
	{
		path: '/pesquisaBoletimSanitario',
		name: 'pesquisaBoletimSanitario',
		component: PesquisaBoletimSanitario
	},
	{
		path: '/boletimSanitario/:idBoletimSanitario?',
		component: BoletimSanitario,
		name: 'boletimSanitario',
		props: route => ({ idLoteProducao: route.query.lp }),
	},
	{
		path: '/mercadoDestino',
		name: 'mercadoDestino',
		component: MercadoDestino
	},
	{
		path: '/detalheMercadoDestino/:idMercadoDestino?/',
		name: 'detalheMercadoDestino',
		component: DetalheMercadoDestino
	},
];
